import CaseStudyItems from "./CaseStudyItems";
function CaseStudies(){

	this.selectedFilters = {};
	this.availableFilters = {};
	this.postsFilters = {};
	this.firstFilter = null;
	this.filtersCount = 0;
	this.loading = false;
	const self = this;
	this.init  = () => {
		if(jQuery('body.page-template-page-case-studies').length === 0) return;

		this.loadFilters();
		this.loadPostsFilters();
		jQuery( '[data-filter]' ).on( 'change', this.handleFilterChange );
		jQuery( '[data-filter-form]' ).on('submit', this.handleFiltersSubmit);
		jQuery( '.case-studies__filters__group__button' ).on('click', this.handleToggleFilterDropdown);
		jQuery('body').on('click', this.closeFilterDropdowns);
		jQuery('.case-studies__filters__item').on('click', (ev) => { ev.stopPropagation(); })
		jQuery('[data-filter-search]').on('keydown', this.handleSearchInputKeydown);
		CaseStudyItems.init();
	}

	this.handleSearchInputKeydown = (ev) => {
		const charCode = ev.keyCode || ev.which;
		if(charCode === 13){
			ev.preventDefault();
			this.refreshFilteredCaseStudies();
		}
	}

	this.closeFilterDropdowns = () => {
		jQuery('.case-studies__filters__group').removeClass('active');
	}

	this.handleToggleFilterDropdown = (ev) => {
		ev.preventDefault();
		ev.stopPropagation();
		const $parent  = jQuery(ev.target).closest('.case-studies__filters__group');
		if(!$parent.hasClass('active')){
			this.closeFilterDropdowns();
		}

		$parent.toggleClass('active');
	}

	this.setLoadingState = (state) => {
		this.loading = state;
		jQuery('.case-studies').toggleClass('case-studies--loading', state);
	}

	this.handleFiltersSubmit = (ev) => {
		ev.preventDefault();
		this.refreshFilteredCaseStudies();
		return false;
	}

	this.refreshFilteredCaseStudies = () => {
		if(this.loading){
			return;
		}
		this.setLoadingState(true);
		jQuery.ajax({
			method: 'post',
			data: this.getSelectedFiltersPostObject()
		})
			.done((response) => {
				jQuery('[data-items-row]').html(response);
				CaseStudyItems.init();
			})
			.always((response) => {
				this.setLoadingState(false);
			})
	}

	this.getSelectedFiltersPostObject = () => {
		const selectedFilters = {};
		for(const filter_key in this.selectedFilters){
			if(Object.keys(this.selectedFilters).length){
				selectedFilters[filter_key] = Object.keys(this.selectedFilters[filter_key].selected);
			}
		}
		selectedFilters.ajax = true;
		selectedFilters.search = jQuery('[data-filter-search]').val();
		return selectedFilters;
	}

	this.loadFilters = () => {
		jQuery( '[data-filter-group]' ).each(
			function(){
				const $group = jQuery( this );

				self.selectedFilters[$group.data( 'filter-group' )] = {
					label: $group.data( 'filter-group-label' ),
					selected: {}
				};
			}
		)
	}

	this.loadPostsFilters = () => {
		this.postsFilters = JSON.parse(jQuery('[data-posts-filters]').val());
	}
	this.getAvailableFilters = () => {
		const availableFilters = {};
		const validPosts = [];
		for(const postId in this.postsFilters){
			let postValid = true;
			for(const postFilter in this.postsFilters[postId]){
				const postFilterValues = this.postsFilters[postId][postFilter];
				let filterValid = false;

				if(Object.keys(this.selectedFilters[postFilter].selected).length === 0 || postFilter === this.firstFilter){
					break;
				}

				for(const selectedFilterValue in this.selectedFilters[postFilter].selected){
					if(postFilterValues.indexOf(selectedFilterValue) !== -1){
						filterValid = true;
						break;
					}
				}
				if(!filterValid){
					postValid = false;
					break;
				}
			}

			if(postValid){
				validPosts.push(this.postsFilters[postId]);

				for(const filter in this.postsFilters[postId]){
					if(typeof availableFilters[filter] === 'undefined'){
						availableFilters[filter] = [];
					}
					for(let i = 0; i < this.postsFilters[postId][filter].length; i++){
						if(availableFilters[filter].indexOf(this.postsFilters[postId][filter][i]) === -1){
							availableFilters[filter].push(this.postsFilters[postId][filter][i]);
						}
					}
				}
			}
		}
		return availableFilters;

	}
	this.disableUnavailableFilters = () => {
		jQuery('input[data-filter]').prop('disabled', true);

		this.enableAvailableFilters();
	}
	this.enableAvailableFilters = () => {
		const availableFilters = this.getAvailableFilters();
		console.log(availableFilters);
		for(const filter in availableFilters){
			if(filter === this.firstFilter){
				jQuery(`input[data-filter="${filter}"]`).prop('disabled', false);
				continue;
			}
			for(let i = 0; i < availableFilters[filter].length; i++){
				const $input = this.getFilterInput(filter, availableFilters[filter][i]);
				$input.prop('disabled', false);
			}
		}
	}

	this.handleFilterChange = (ev) => {
		ev.preventDefault();
		const $input        = jQuery( ev.target );
		const filter_key    = $input.data( 'filter' );
		const filter_label  = $input.data( 'filter-label' );
		const value         = $input.val();
		if ($input.is( ':checked' )) {
			this.selectedFilters[filter_key].selected[value] = filter_label;
			if(this.firstFilter === null){
				this.firstFilter = filter_key;
			}
		} else {
			this.deleteSelectedFilter( filter_key, value )
		}
		this.onFiltersChange();
	}

	this.renderSelectedFilters          = () => {
		const $selectedFiltersContainer = jQuery( '[data-selected-filters]' );
		const $filtersCount = jQuery( '[data-filter-count]' );
		this.filtersCount = 0;
		$selectedFiltersContainer.empty();
		for (const filterKey in this.selectedFilters) {
			const filter = this.selectedFilters[filterKey];
			if (Object.keys( filter.selected ).length === 0) {
				continue;
			}
			const $group      = jQuery( document.createElement( 'div' ) )
				.addClass( 'case-studies__selected-filters__group' );
			const $row      = jQuery( document.createElement( 'div' ) )
				.addClass( 'case-studies__selected-filters__row' );
			const $groupLabel = jQuery( document.createElement( 'span' ) )
				.addClass( 'case-studies__selected-filters__label' )
				.text( filter.label );
			$group.append( $groupLabel );

			for (const value in filter.selected) {
				$row.append( this.createSelectedFilterElement( filterKey, value, filter.selected[value] ) );
				this.filtersCount++;
			}
			$group.append($row);

			$selectedFiltersContainer.append( $group );
		}
		$filtersCount.text(this.filtersCount);
		$filtersCount.toggleClass('active', this.filtersCount > 0);
		if(this.filtersCount === 0){
			this.firstFilter = null;
		}
	}

	this.createSelectedFilterElement = (key, value, label) => {

		const $el     = jQuery( document.createElement( 'div' ) )
			.addClass( 'case-studies__selected-filters__item' );
		const $delete = jQuery( document.createElement( 'button' ) )
			.addClass( 'case-studies__selected-filters__item__delete' )
			.attr('title', `Remove ${label}`)
		const $label  = jQuery( document.createElement( 'span' ) )
			.addClass( 'case-studies__selected-filters__item__label' )
			.text( label );

		$delete.data( 'key', key );
		$delete.data( 'value', value );
		$delete.on( 'click', this.handleDeleteSelectedFilter );

		$el.append( $label );
		$el.append( $delete );
		return $el;
	}

	this.handleDeleteSelectedFilter = (ev) => {
		ev.preventDefault();

		const $filter = jQuery( ev.target );
		this.deleteSelectedFilter( $filter.data( 'key' ), $filter.data( 'value' ) );
		this.onFiltersChange();
	}

	this.onFiltersChange = () => {
		this.renderSelectedFilters();
	}

	this.deleteSelectedFilter = (key, value) => {
		if (typeof this.selectedFilters[key].selected[value] !== 'undefined') {
			delete this.selectedFilters[key].selected[value];
			this.deselectFilterInput( key, value );
		}
	}
	this.getFilterInput = (key, value) => {
		return jQuery( `[data-filter="${key}"][value="${value}"]` );
	}
	this.deselectFilterInput = (key, value) => {
		const $input = this.getFilterInput(key, value);
		if ($input.length) {
			$input.attr( 'checked', false );
			$input[0].checked = false;
		}
	}
}
export default new CaseStudies();
